var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import { Form, StyledField, SubmitButton } from './style';
export var WatchlistShareForm = function (_a) {
    var onSubmit = _a.onSubmit;
    var intl = useIntl();
    var inputPlaceholder = defineMessages({
        inputPlaceholder: {
            id: 'action.share.mailPlaceholder',
            defaultMessage: 'Ihre E-Mail-Adresse',
        },
    }).inputPlaceholder;
    return (_jsx(FinalForm, { onSubmit: function (values) { return onSubmit(values); }, render: function (_a) {
            var handleSubmit = _a.handleSubmit;
            return (_jsxs(Form, __assign({ onSubmit: handleSubmit }, { children: [_jsx(StyledField, { autoComplete: 'off', component: 'input', name: 'email', placeholder: intl.formatMessage(inputPlaceholder), required: true, type: 'email' }, void 0), _jsx(SubmitButton, __assign({ type: 'submit' }, { children: _jsx(FormattedMessage, { id: 'action.share.mailSubmit', defaultMessage: 'Abschicken' }, void 0) }), void 0)] }), void 0));
        } }, void 0));
};
export default WatchlistShareForm;
